import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectOrderBook, selectQuickTradeQuoteSignature } from '../../../../selectors/security'
import { parseQuickTradeQuoteSignature } from '../../../../util/quickTradeQuote'
import QuickTradePriceOffsetField, { type QuickTradePriceOffsetFieldProps } from './QuickTradePriceOffsetField'

export type QuickTradePriceOffsetFieldWithLiveQuoteProps = Omit<
    QuickTradePriceOffsetFieldProps,
    'quote' | 'orderBook'
> & {
    liveQuoteSecurityKey: string
}

const QuickTradePriceOffsetFieldWithLiveQuote: React.FC<QuickTradePriceOffsetFieldWithLiveQuoteProps> = ({
    liveQuoteSecurityKey,
    ...fieldProps
}) => {
    const signature = useSelector(selectQuickTradeQuoteSignature(liveQuoteSecurityKey)) as string
    const orderBook = useSelector(selectOrderBook(liveQuoteSecurityKey))
    const quote = useMemo(() => parseQuickTradeQuoteSignature(signature), [signature])

    return <QuickTradePriceOffsetField {...fieldProps} quote={quote} orderBook={orderBook} />
}

export default memo(QuickTradePriceOffsetFieldWithLiveQuote)
